<cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "Stammgrundstueck" | translate }}
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <thead>
            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
          </thead>
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
    <ng-template #tableHeaders>
      <tr>
        <th style="width: 20%">{{ "Grundstueck" | translate }}</th>
        <th style="width: 20%">
          <span class="float-end pe-3">
            {{ "Anteil" | translate }}
          </span>
        </th>
        @if (hasParzellenindex) {
          <th style="width: 20%">
            {{ "Index" | translate }}
          </th>
        }
        <th style="width: 60%">
          {{ "Rechtsgrund" | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template #tableRows>
      @for (eigentumanteil of listLoader?.items; track eigentumanteil) {
        @if (eigentumanteil.belastetesGrundstueck) {
          @for (version of eigentumanteil.versions; track version; let last = $last) {
            <tr>
              <td [capHistinfo]="eigentumanteil.belastetesGrundstueck.histInfo">
                <cap-kompakt-grundstueck [item]="eigentumanteil.belastetesGrundstueck" [navigateTo]="navigateTo"></cap-kompakt-grundstueck>
              </td>
              <td>
                <span [capHistinfo]="version.histInfo" class="float-end pe-3">
                  {{ version.quote.zaehler }}/{{ version.quote.nenner }}
                </span>
                <cap-kompakt-timepoint [item]="version.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
              </td>
              @if (hasParzellenindex) {
                <td [capHistinfo]="version.histInfo">
                  {{ version.parzellenindex }}
                </td>
              }
              <td>
                @if (last) {
                  @for (rechtsgrund of eigentumanteil.rechtsgruende; track rechtsgrund) {
                    <div>
                      @if (rechtsgrund && rechtsgrund.histInfo) {
                        <span class="mb-0">
                          <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
                        </span>
                      }
                    </div>
                  }
                }
              </td>
            </tr>
          }
        }
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
